import { render, staticRenderFns } from "./DocumentPowerpointDocument.vue?vue&type=template&id=4506adb6&scoped=true"
import script from "./DocumentPowerpointDocument.vue?vue&type=script&lang=js"
export * from "./DocumentPowerpointDocument.vue?vue&type=script&lang=js"
import style0 from "./DocumentPowerpointDocument.vue?vue&type=style&index=0&id=4506adb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4506adb6",
  null
  
)

export default component.exports